import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/api/query-keys';
import { listTeamAlerts, markTeamAlertRead } from '@/api/endpoints/notifications';

export function useTeamAlerts(enabled = true) {
  return useQuery({
    queryKey: queryKeys.teamAlerts.list(),
    queryFn: listTeamAlerts,
    enabled,
  });
}

export function useMarkTeamAlertRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markTeamAlertRead(id),
    // The row stays in the list with its `readAt` set, so the list is refetched
    // rather than patched: what the stamp looks like is the backend's.
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.teamAlerts.all() }),
  });
}
